// Wunschliste im Browser des Kunden. Speichert nur Produkt-Handles, keine personenbezogenen Daten.
const KEY = 'oo:wishlist:v1';
const MAX_ITEMS = 60;
const HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;

export function isValidHandle(handle) {
  return typeof handle === 'string' && HANDLE.test(handle);
}

export function parseWishlist(raw) {
  if (typeof raw !== 'string' || raw === '') return [];
  let data;
  try {
    data = JSON.parse(raw);
  } catch {
    return [];
  }
  if (!Array.isArray(data)) return [];
  const unique = [];
  for (const handle of data) {
    if (isValidHandle(handle) && !unique.includes(handle)) unique.push(handle);
    if (unique.length === MAX_ITEMS) break;
  }
  return unique;
}

export function toggleHandle(list, handle) {
  if (!isValidHandle(handle)) return list;
  if (list.includes(handle)) return list.filter((h) => h !== handle);
  return [handle, ...list].slice(0, MAX_ITEMS);
}

function storage() {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    // Zugriff kann im privaten Modus oder bei blockierten Cookies werfen.
    return null;
  }
}

export function readWishlist(store = storage()) {
  if (!store) return [];
  try {
    return parseWishlist(store.getItem(KEY));
  } catch {
    return [];
  }
}

export function writeWishlist(list, store = storage()) {
  if (!store) return false;
  try {
    store.setItem(KEY, JSON.stringify(parseWishlist(JSON.stringify(list))));
    return true;
  } catch {
    return false;
  }
}

// Widerruf (oo-withdrawal.js): Angaben für die Eingangsanzeige, nur im Sitzungsspeicher und höchstens 30 Minuten.
// Bricht das Absenden ab, räumt oo-layout.js den abgelaufenen Datensatz auf der nächsten Seite weg (nur nach Alter,
// damit er auf einer Zwischenseite wie der Shopify-Captcha-Prüfung erhalten bleibt).
export const WITHDRAWAL_KEY = 'oo:withdrawal:v1';
export const WITHDRAWAL_MAX_AGE = 30 * 60 * 1000;

function sessionStore() {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    return null;
  }
}

export function dropStaleWithdrawal(store = sessionStore(), now = Date.now()) {
  try {
    const raw = store?.getItem(WITHDRAWAL_KEY);
    if (!raw) return;
    let at;
    try {
      at = JSON.parse(raw)?.at;
    } catch {
      at = undefined;
    }
    if (!(typeof at === 'number' && at <= now && now - at < WITHDRAWAL_MAX_AGE)) store.removeItem(WITHDRAWAL_KEY);
  } catch {
    // Speicher gesperrt: nichts zu tun
  }
}

// Versandkosten-Leiste: was bis zur Grenze fehlt, wie voll der Balken ist und in welcher Stufe (Beträge in Cent).
// Stufen start, near ab 50 %, almost ab 75 %, done; das Mädchen am Warenkorb-Knopf nutzt nur „erreicht“.
export function freeShippingState(total, goal) {
  const remaining = Math.max(0, goal - total);
  const progress = goal > 0 ? Math.min(100, Math.floor((total / goal) * 100)) : 0;
  const reached = goal > 0 && remaining === 0;
  let stage = 'start';
  if (reached) stage = 'done';
  else if (progress >= 75) stage = 'almost';
  else if (progress >= 50) stage = 'near';
  return { remaining, progress, reached, stage };
}
